<template>
<div class="first-time-visitor-component">
      <collapsible-box :initCollapse="isCollpase">
        <template v-slot:title>
        <span class="title-visitor">First time visiting the new Safelite For Agents site?</span> <span class="get-started"> Get started </span>
    </template>
        <div class="search-container">
                <div class="search-div">
                    <span class="search-label"> Enter your email</span>
                    <SearchbarWithButton @value-changed="resetError()" @button-clicked="checkUserEmail" :class="{ 'has-error': isError}" v-model="email" class="search-input" :options="searchbarOptions" buttonText="Find" />
                </div>

                <div class="search-div-mobile">
                    <div class="search-label"> Enter your email</div>
                    <input type="text" v-model="email" placeholder="Enter your email address" @input="resetError()" class="full-width" :class="{ 'has-error': isError}">

                    <div v-if="isError" class="show-error mx-auto">{{ error_msg }}</div>
                    <div v-if="userResponse.status === 'ACTIVE'" class="success-msg">
                        <div class="bmsg mb-3"> <img class="check-circle" src="~@/assets/icons/check-circle.png" alt="" />
                            <div> Welcome back! </div>
                        </div>
                        <span class="nmsg">Forgot your password? No worries. </span>
                        <a href="/dashboard/forgotpassword" class="link">Reset it now</a>
                    </div>

                    <div v-if="userResponse.status === 'PROVISIONED'" class="success-msg">
                        <div class="bmsg mb-3"> <img class="check-circle" src="~@/assets/icons/check-circle.png" alt="" />
                            <div> Great to see you again! </div>
                        </div>
                        <span class="nmsg">You need to <a href="/dashboard/forgotpassword" class="link">create a password </a> this site.</span>
                    </div>

                    <div v-if="userResponse.status === null" class="success-msg">
                        <div class="bmsg mb-3"> <img class="check-circle" src="~@/assets/icons/check-circle.png" alt="" />
                            <div> Welcome! </div>
                        </div>
                        <span class="nmsg">You must be new here. </span>
                        <a href="/dashboard/find-my-agency" class="link"> Create your account</a>
                    </div>

                    <div v-if="userResponse.status === 'STAGED'" class="success-msg">
                        <div class="bmsg mb-3"> <img class="check-circle" src="~@/assets/icons/icons-alert-circle.png" alt="" />
                            <div> Welcome! </div>
                        </div>
                        <span class="nmsg">Looks like we need to manually complete your account activation. Call us at <span class="link">877-792-4368.</span></span>
                    </div>


                    <div v-if="userResponse.status === 'DEPROVISIONED' || userResponse.status === 'SUSPENDED'" class="success-msg">
                        <div class="bmsg mb-3"> <img class="check-circle" src="~@/assets/icons/icons-alert-circle.png" alt="" />
                            <div> Welcome! </div>
                        </div>
                        <span class="nmsg">Give us a quick call at <span class="link">877-792-4368</span> and we’ll get you on your way.</span>
                    </div>

                    <button @click="checkUserEmail" class="pill-btn blue filled full-width-mobile mt-5">
                        Find
                    </button>
                </div>

                <div class="desktop-ver">
                    <div v-if="isError" class="show-error mx-auto">{{ error_msg }}</div>
                    <div v-if="userResponse.status === 'ACTIVE'" class="success-msg">
                        <div class="bmsg mb-3"> <img class="check-circle" src="~@/assets/icons/check-circle.png" alt="" />
                            <div> Welcome back! </div>
                        </div>
                        <span class="nmsg">Forgot your password? No worries. </span>
                        <a class="link" href="/dashboard/forgotpassword">Reset it now</a>
                    </div>

                    <div v-if="userResponse.status === 'PROVISIONED'" class="success-msg">
                        <div class="bmsg mb-3"> <img class="check-circle" src="~@/assets/icons/check-circle.png" alt="" />
                            <div> Great to see you again! </div>
                        </div>
                        <span class="nmsg">You need to <a class="link" href="/dashboard/forgotpassword">create a password </a> for this site.</span>
                    </div>

                    <div v-if="userResponse.status === null" class="success-msg">
                        <div class="bmsg mb-3"> <img class="check-circle" src="~@/assets/icons/check-circle.png" alt="" />
                            <div> Welcome! </div>
                        </div>
                        <span class="nmsg">You must be new here. </span>
                        <span><a class="link" href="/dashboard/find-my-agency"> Create your account</a></span>
                    </div>

                     <div v-if="userResponse.status === 'STAGED'" class="success-msg">
                        <div class="bmsg mb-3"> <img class="check-circle" src="~@/assets/icons/icons-alert-circle.png" alt="" />
                            <div> Welcome! </div>
                        </div>
                        <span class="nmsg">Looks like we need to manually complete your account activation. Call us at <span class="link">877-792-4368.</span></span>
                    </div>

                    
                    <div v-if="userResponse.status === 'DEPROVISIONED' || userResponse.status === 'SUSPENDED'" class="success-msg">
                        <div class="bmsg mb-3"> <img class="check-circle" src="~@/assets/icons/icons-alert-circle.png" alt="" />
                            <div> Welcome! </div>
                        </div>
                        <span class="nmsg">Give us a quick call at <span class="link">877-792-4368</span> and we’ll get you on your way.</span>
                    </div>

                </div>
            </div>
      
    </collapsible-box>
</div>
</template>

<script>
import CollapsibleBox from '@/sharedcomponents/CollapsibleBox/CollapsibleBox.vue'
import SearchbarWithButton from "@/sharedcomponents/SearchbarWithButton.vue";
import { useUserStore } from "@/stores/user.js"

export default {
    name: "first-time-visitor-component",
    setup() {
        const userStore = useUserStore();
        return { userStore };
    },
    components: {
        CollapsibleBox,
        SearchbarWithButton
    },
    data: function () {
        return {
            userResponse: "",
            isCollpase: true,
            error_msg: "",
            isError: false,
            searchbarOptions: {
                preventSpaces: true,
                placeholder: "Enter your email address",
                name: "userEmail"
            },
            email: ""
        }
    },
    methods: {        
        resetError() {
            this.isError = false;
        },
        checkUserEmail() {
            if (this.emailValidation()) {
                this.userStore.checkUserStatusAsync({
                    userName: this.email,
                    blocking: true
                }).then(response => {
                    this.userResponse = response;
                }).catch(err => console.log(err));
            }
        },

        emailValidation() {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(this.email)) {               
                this.isError = true;
                this.error_msg = "Please enter a valid email address";
                return false;
            } else {
                this.isError = false;
                this.error_msg = '';
                return true;
            }
        },
    }
}

</script>

<style lang="scss">
.first-time-visitor-component {

    border-radius: 5px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    background-color: $grayscale-seven;



    .has-error {
        border-color: $red;

        &:focus {
            @include box-shadow-mixin(0 0 0 5px $red-thirty);
        }
    }

    .collapsible-box.closed.all-screen-sizes {
    padding-bottom: 1px !important;

    .collapsible {
        border: none;
        display:block;
    }
}
    .collapsible-box {
        border: none;
        padding: 20px 30px;

        .search-div-mobile {
            display: none;
        }

        .desktop-ver {
            display: block;
            .show-error {
                width: 70% !important;
            }
        }

        .title-visitor {
            font-family: $font-family-primary;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.56;
            letter-spacing: normal;
            color: $grayscale-two;
        }

        .get-started {
            font-family: $font-family-primary;
            font-size: 16px;
            font-weight: $font-weight-semibold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.56;
            letter-spacing: normal;
            color: $blue;
            margin-left: 10px;
        }

        .chevron::before {
            content: none !important;
        }

        .chevron::after {
            content: none !important;
        }

        .chevron {

            position: unset !important;

            .arrow {
                height: 20px;
                background: url("~@/assets/icons/icons-chevron-circle-new.svg") no-repeat right;
            }
        }

        .collapsible-content {
            padding-top: 20px !important;
            border-top: $grayscale-five !important;
            border-top-style: solid !important;
            border-top-width: 1px !important;
        }

        

        .search-container {
            display: flex;
            flex-direction: column;

            .success-msg {
                font-size: 16px;
                display: flex;

                font-stretch: normal;
                font-style: normal;
                line-height: 1.56;
                letter-spacing: normal;
                color: $grayscale-one;
                margin-top: 20px;

                img {
                    margin-right: 10px;
                    height: 20px;
                    width: 20px;
                }

                .bmsg {
                    font-weight: $font-weight-bold;
                    margin-right: 10px;
                    flex-direction: row;
                    display: flex;
                }

                .nmsg {
                    margin-right: 5px;
                    color: $grayscale-two;
                }
            }

        }

        .search-div {
            display: flex;
            flex-direction: row;

            .search-label {
                font-family: $font-family-primary;
                font-size: 16px;
                font-weight: $font-weight-bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.56;
                letter-spacing: normal;
                color: $grayscale-one;
                margin-top: 8px;
            }

            .search-input {
                width: 86%;
                margin: 0px 0px 0px 10px;
            }
        }

    }

}
@include wide-mobile {
    .first-time-visitor-component {
        margin: 15px !important;
        padding: 20px 15px !important;

        .collapsible-box {
            padding: 0px;
            margin-bottom: 0px !important;

            .desktop-ver {
                display: none;
            }

            .search-container {
                .success-msg {
                    flex-direction: column;

                    .bmsg {
                        flex-direction: row;
                        display: flex;
                    }
                    .nmsg {
                        margin-right: 0px;
                        color: $grayscale-two;
                    }
                }

                .search-div-mobile {
                    display: block;

                    .search-label {
                        font-weight: $font-weight-bold;
                        color: $grayscale-one;
                        margin-bottom: 5px !important;
                    }

                    .pill-btn {
                        margin-bottom: 10px;
                    }
                }

                .search-div {
                    display: none;

                }
            }

            .get-started {
                margin-left: 0px !important;
                margin-top: 10px;
                display: block;
                margin-bottom: 20px;
            }

             .collapsible-head {
                 padding-bottom: 19px !important;
            }

            .closed.all-screen-sizes {
                padding-bottom: 0px !important;
            }
        }
    }
}
</style>
